var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.09375532891186644 0 50.21875532891187 24.817863323270206",
    width: 2500,
    height: 1233,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.326 1.406v18.023H9.157v-.823a5.108 5.108 0 0 1-3.265 1.09A5.92 5.92 0 0 1 0 13.491 5.91 5.91 0 0 1 5.89 7.24a5.18 5.18 0 0 1 3.213 1.04V1.406zM9.204 13.49a2.968 2.968 0 0 0-3.033-3.119 2.956 2.956 0 0 0-2.958 3.12 2.94 2.94 0 0 0 2.956 3.07 2.957 2.957 0 0 0 3.033-3.07m6.35-5.987h3.217v11.924h-3.217zm17.533 0v11.573a5.55 5.55 0 0 1-5.89 5.623 5.555 5.555 0 0 1-5.54-3.816l2.956-1.106a2.493 2.493 0 0 0 2.576 1.827 2.493 2.493 0 0 0 2.673-2.61v-.972a4.733 4.733 0 0 1-3.052 1.02 5.644 5.644 0 0 1-5.64-5.872 5.665 5.665 0 0 1 5.607-5.92 4.758 4.758 0 0 1 3.12 1.09v-.827h3.188v-.01zm-3.129 5.673a2.78 2.78 0 1 0-5.558-.001 2.78 2.78 0 0 0 5.558 0m6.346-5.672h3.218v11.924h-3.218zm10.06 0h3.763v3.052H46.36v4.418a1.312 1.312 0 0 0 1.406 1.406h2.358v3.052h-3.033a3.691 3.691 0 0 1-3.926-3.86v-5.02h-1.703V8.9l3.119-3.86h1.78zM17.153 1.428h15.931v2.516h-15.93z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.521 2.683L37.09 0h-.787v5.384h.779z",
    fill: "#fb0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitInsurance);
export default __webpack_public_path__ + "static/media/digit-insurance.b1c881177a47743b7178106863b9d87c.svg";
export { ForwardRef as ReactComponent };